export enum QueryStringPrimaryKeys {
	SEARCH = "query",
	SORT = "sort",
	PAGE = "page",
	AVAILABLE_PURCHASE_COURSES = "purchase-only",
	SHOW_NUMBER_PRODUCTS = "number-products",
	PRODUCTS_VISIBILITY = "view"
}
